export const nativeCoins = [
    {
    chainId: 0,
    name: 'Kardiachian',
    symbol: 'KAI',
    decimals: 18,
    wrappedSymbol: 'WKAI',
    allowance: Infinity,
    address: "0xAF984E23EAA3E7967F3C5E007fbe397D8566D23d"
  }
];
